<template>
  <b-container>
    <ArtistEditProfileTabs />

    <b-row>
      <b-col class="hero">
        <img class="hero" :src="artistHero">
        <h1>{{ artist.name }}</h1>

        <div class="avatar">
          <img class="avatar" :src="artistAvatar">
          <img class="avatar avatar-change-btn" src="/static/icons/change-picture.png" @click="selectAvatar">
          <input type="file" id="avatarFileInput" ref="avatarFileInput" @change="updateAvatar" />
        </div>
        <b-button class="btn-secondary" @click="selectHero">change profile image</b-button>
        <input type="file" id="heroFileInput" ref="heroFileInput" @change="updateHero" />
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col class="img-req" cols="12" md="6">
        Avatar image: .png, .jpg / 370 x 370 px minimum
      </b-col>
      <b-col class="img-req text-right" cols="12" md="6">
        Profile image: .png, .jpg / 1140 x 480 px minimum
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col>
        <b-form-group id="handleGroup"
                      label="Artist Handle"
                      label-for="handle"
                      description="Your artist handle (@artist), can't be changed">
          <b-form-input id="handle" type="text" required disabled :value="'@' + artist.handle" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="nameGroup"
                      label="Name"
                      label-for="name"
                      :invalidFeedback="errorName"
                      :state="stateName"
                      description="Your artist name">
          <b-form-input id="name" type="text" required placeholder="Enter your artistic name" v-model="artist.name" :state="stateName" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group id="emailGroup"
                      label="Contact Email"
                      label-for="email"
                      :invalidFeedback="errorEmail"
                      :state="stateEmail"
                      description="Visible on receipts for those who make purchases or donations">
          <b-form-input id="name" type="email" required placeholder="Enter your official contact e-mail address" v-model="artist.email" :state="stateEmail" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="locationGroup"
                      label="Location"
                      label-for="location"
                      description="Your location">
        <vue-google-autocomplete id="location"
                                 classname="form-control"
                                 placeholder="Start typing"
                                 types="(cities)"
                                 :value="artist.location"
                                 v-on:placechanged="onPlaceChanged" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group id="bioGroup"
                      label="Bio"
                      label-for="bio"
                      description="Tell us your story">
          <b-form-textarea id="bio" :rows="5" :max-rows="10" required placeholder="Who are you?" v-model="artist.bio"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Genre (up to 3)">
          <multiselect v-model="genres"
                       :searchable="false"
                       :multiple="true"
                       :max="3"
                       :showNoResults="false"
                       :options="genreOptions">
            <template slot="maxElements">
              Maximum of 3 options
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Mood (up to 2)">
          <multiselect v-model="moods"
                       :searchable="false"
                       :multiple="true"
                       :max="2"
                       :showNoResults="false"
                       :options="moodOptions">
            <template slot="maxElements">
              Maximum of 2 options
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="form-actions">
      <b-col>
        <a class="cancel" href="#" @click="cancel">cancel</a>
        <b-button class="btn-rainbow" @click="save">save information</b-button>
      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .col {
    @include media-breakpoint-down(xs) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  .hero {
    position: relative;

    img.hero {
      width: 100%;
      min-height: 300px;
      object-fit: cover;
    }

    h1 {
      position: absolute;
      left: 30px;
      bottom: 20px;
      color: $bluish-white;
      text-shadow: 2px 2px 0 #000;
      font-size: 2.5rem;
      margin: 0 0 .5rem 0;
    }

    .avatar {
      position: absolute;
      left: 15px;
      bottom: 45px;

      img.avatar {
        width: 100px;
        height: 100px;
        border-radius: 100%;
      }

      .avatar-change-btn {
        cursor: pointer;
      }

      #avatarFileInput {
        display: none;
      }
    }

    button.btn-secondary {
      right: 20px;
      bottom: 10px;
      position: absolute;
      @include media-breakpoint-down(xs) {
        bottom: auto;
        top: 6px;
      }
    }

    #heroFileInput {
      display: none;
    }
  }

  .img-req {
    font-size: 0.8em;
    color: $steel;
  }

  @include media-breakpoint-down(sm) {
    .img-req {
      text-align: center !important;
    }
  }

  .profile-tabs {
    margin-top: 1em;
    margin-bottom: 1em;

    /deep/ a {
      color: $white;

      &.active {
        color: $white;
        border-bottom: 2px solid $white;
      }

      margin-bottom: -2px;
    }

    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.5);
    margin-bottom: 2em;
  }

  h3 {
    margin-top: 1em;
  }

  /deep/ .multiselect {
    .multiselect__tag {
      color: $white;
      background-color: $darkish-pink-three;

      .multiselect__tag-icon:after {
        color: white;
      }

      .multiselect__tag-icon:focus,
      .multiselect__tag-icon:hover,
      .multiselect__tag-icon:hover:after {
        background-color: $darkish-pink;
      }
    }

    .multiselect__option--highlight,
    .multiselect__option--highlight:after {
      background-color: $darkish-pink;
    }
  }

  .form-actions {
    text-align: right;
    /deep/ button {
      padding-left: 2em;
      padding-right: 2em;
    }
    a.cancel {
      color: $bluish-white;
      text-decoration: underline;
      margin-right: 2em;
    }
  }
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import Multiselect from 'vue-multiselect'

import { genres, moods } from '@/store/modules/tag'
import ArtistEditProfileTabs from '@/components/widgets/ArtistEditProfileTabs'
import { parseErrors, mapErrorStates } from '@/store/helpers'

export default {
  name: 'ArtistEditProfile',
  components: {
    ArtistEditProfileTabs,
    VueGoogleAutocomplete,
    Multiselect
  },
  data () {
    return {
      errors: {},
      genres: [],
      moods: [],
      genreOptions: genres,
      moodOptions: moods
    }
  },
  computed: {
    ...mapGetters('artist', ['artist', 'artistAvatar', 'artistHero']),
    ...mapErrorStates(['name', 'email'])
  },
  created () {
    this.parseTags()
  },
  methods: {
    parseTags () {
      this.genres = []
      this.moods = []

      for (let tag of this.artist.tags) {
        if (genres.indexOf(tag) !== -1) {
          this.genres.push(tag)
        }
        if (moods.indexOf(tag) !== -1) {
          this.moods.push(tag)
        }
      }
    },
    async save () {
      this.artist.tags = this.genres.concat(this.moods)

      try {
        await this.$store.dispatch('artist/updateArtist')
        this.$store.dispatch('flash/showMessage', {message: 'You\'ve updated your artist profile'})
        this.$router.push({name: 'artist-dashboard'})
      } catch (e) {
        this.$store.dispatch('flash/showMessage', {message: 'Error updating artist profile', type: 'error'})
        if (e.response && e.response.data) {
          this.errors = parseErrors(e.response.data)
        }
      }
    },
    cancel () {
      this.$store.dispatch('artist/getCurrentArtist').then(() => {
        this.$router.push({name: 'artist-dashboard'})
      })
    },
    selectAvatar () {
      this.$refs.avatarFileInput.click()
    },
    async updateAvatar () {
      let input = this.$refs.avatarFileInput
      if (input.files.length !== 1) {
        return
      }

      this.showModal('Uploading image ...')
      await this.$store.dispatch('artist/setAvatar', {file: input.files[0]})
      this.hideModal()
    },
    selectHero () {
      this.$refs.heroFileInput.click()
    },
    async updateHero () {
      let input = this.$refs.heroFileInput
      if (input.files.length !== 1) {
        return
      }

      this.showModal('Uploading image ...')
      await this.$store.dispatch('artist/setHero', {file: input.files[0]})
      this.hideModal()
    },
    onPlaceChanged (addr, place, id) {
      this.artist.location_lat = addr.latitude
      this.artist.location_lng = addr.longitude
      this.artist.location = place.formatted_address
    },
    ...mapActions('flash', ['showModal', 'hideModal'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/EditProfile.vue